module.exports = __webpack_public_path__ + "static/media/Manuel_1_Radionucléide_3.0.99ce1d30.pdf";